/**
 * Neighborhood and article images are stored once at w=1200 because the same URL is reused
 * as the page hero and as the og:image. Card thumbnails render at ~290–330 CSS px, so serving
 * the 1200px original there wastes ~200 KB per card — which matters now that prerendering puts
 * these <img> tags in the initial HTML, where they compete with fonts and CSS for bandwidth.
 *
 * Rewrites the width parameter for hosts that support it. Returns the URL untouched otherwise,
 * so a non-Unsplash or relative image (e.g. /world-cup-soccer-ball.webp) passes through safely.
 */
export function sizedImage(url, width) {
  if (!url || typeof url !== 'string') return url;
  if (!/(^https?:)?\/\/(images|plus)\.unsplash\.com\//.test(url)) return url;

  const [base, query = ''] = url.split('?');
  const params = new URLSearchParams(query);
  params.set('w', String(width));
  // Retina cards still look sharp at a lower quality once downscaled.
  if (!params.has('q')) params.set('q', '75');
  return `${base}?${params.toString()}`;
}
